/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosCarousel, CosmosCarouselProps } from "@components/elements";

export type ImageCarouselProps = CosmosCarouselProps;

export const ImageCarousel = ({ ...props }: ImageCarouselProps): React.JSX.Element => {
	return <CosmosCarousel buttonPosition="inside" slidesInView={1} thumbnails={true} {...props} />;
};
